import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

pageTop()
function pageTop() {
  if (!document.getElementById('page-top')) {
    return
  }

  //  ##   ##  ##  ####    #####   #####
  //  ##   ##  ##  ##  ##  ##     ##   ##
  //  ##   ##  ##  ##  ##  #####  ##   ##
  //   ## ##   ##  ##  ##  ##     ##   ##
  //    ###    ##  ####    #####   #####

  // YouTubeのAPIを呼び出す
  const tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

  /* global YT */
  let topMovie1
  let topMovie2
  window.onYouTubeIframeAPIReady = function () {
    topMovie1 = new YT.Player(
      'topMovie1', // プレイヤーに変化させる要素のID
      {
        videoId: 'JDNQgItS3f4', // 動画ID
        width: 1920, // 幅
        height: 1080, // 高さ
        playerVars: {
          playsinline: 1, // インライン再生(iOS環境で制御に必要)
          controls: 0, // コントローラー
          rel: 0, // おすすめ動画
          showinfo: 0, // タイトル
          disablekb: 1, // キーボード操作の禁止
          color: 'white', // シークバーの色（red/white）
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      }
    )
    topMovie2 = new YT.Player(
      'topMovie2', // プレイヤーに変化させる要素のID
      {
        videoId: '0o2H0T2Sha8', // 動画ID
        width: 1920, // 幅
        height: 1080, // 高さ
        playerVars: {
          playsinline: 1, // インライン再生(iOS環境で制御に必要)
          controls: 0, // コントローラー
          rel: 0, // おすすめ動画
          showinfo: 0, // タイトル
          disablekb: 1, // キーボード操作の禁止
          color: 'white', // シークバーの色（red/white）
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      }
    )
  }
  function onPlayerReady(e) {
    // 再生準備完了時の処理
    e.target.mute() // ミュートにする（しないとブラウザに自動再生を拒否される）
    e.target.playVideo() // 再生開始
  }
  function onPlayerStateChange(e) {
    // 動画の状態変化時の処理
    if (e.data === YT.PlayerState.PLAYING) {
      // 再生中
      setTimeout(() => {
        document.getElementById('topMovie').classList.add('active')
      }, 300)
    }
    if (e.data === YT.PlayerState.PAUSED) {
      // 停止
    }
    if (e.data === YT.PlayerState.BUFFERING) {
      // バッファリング中
    }
    if (e.data === YT.PlayerState.CUED) {
      // 頭出し済み
    }
    if (e.data === YT.PlayerState.ENDED) {
      // 再生終了
      e.target.playVideo() // 再度再生
    }
  }

  //  #####   ##  ######
  //  ##  ##  ##     ##
  //  #####   ##    ##
  //  ##  ##  ##   ##
  //  #####   ##  ######

  let topBizSwiper
  if (document.getElementById('topBiz')) {
    // SP時だけスライダーにする
    if (window.matchMedia('(max-width:768px)').matches) {
      topBizSwiperInit()
    }
    window.addEventListener('resize', function (e) {
      if (topBizSwiper && window.matchMedia('(min-width:769px)').matches) {
        topBizSwiper.destroy()
        topBizSwiper = false
      } else if (!topBizSwiper && window.matchMedia('(max-width:768px)').matches) {
        topBizSwiperInit()
      }
    })
  }
  function topBizSwiperInit() {
    const slideItem = document.getElementById('topBiz')
    const sliderName = 'topBiz'
    topBizSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（topBizSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1.4, //表示数変更
      spaceBetween: 20, //スライド同士の間隔を空ける
      // slideToClickedSlide: true, // クリックしたスライドをアクティブにする
      centeredSlides: true, // 中央のスライドを基準にする
      touchRatio: 0.9, // タッチスワイプ感度（0でタッチスワイプ無効）
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },
    })
  }
}
